import { words } from "./Dictionery";
import { dnyamicLangWords } from "./DynamicLanguage";
import { versionInfo } from "../components/MainPage/VersionInfo";
import { ReVAMPWords } from "./ReVAMPDictionary";
// import moment from 'moment';
export function languageService(word) {
  let lang = localStorage.getItem("language") ? localStorage.getItem("language") : "en";
  const staticDictionaryWords = versionInfo.isReVAMP() ? ReVAMPWords : words;
  // moment.locale(lang);
  return dnyamicLangWords[word]
    ? dnyamicLangWords[word][lang]
    : staticDictionaryWords[word]
      ? staticDictionaryWords[word][lang]
        ? staticDictionaryWords[word][lang]
        : word
      : word;
}

export function getLanguageLocal() {
  return localStorage.getItem("language") ? localStorage.getItem("language") : "en";
}



// WEBPACK FOOTER //
// ./src/Language/language.service.js